import { Chip, Stack, Typography } from '@mui/material';
import { Model } from '../models';
import { Api } from '../api';
import { format, parseISO } from 'date-fns';

type Props = {
  subscription: Api.UserStats.V['subscription'];
};

export default function SubscriptionBadge({ subscription }: Props) {
  const { organisation } = Model.User.getTeamAndOrganisation(subscription);
  const subscriptionLabel = Model.User.getSubscriptionStatusLabel(subscription);
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Chip
        label={subscriptionLabel}
        size="small"
        color={
          subscriptionLabel === 'Active'
            ? 'success'
            : subscriptionLabel.includes('revoked')
              ? 'warning'
              : 'error'
        }
        sx={{ borderRadius: 1 }}
      />
      {!organisation && <Typography>Individual</Typography>}
      {subscription.licence?.revokedAt &&
        subscription.isActive &&
        subscription.licence.expiresAt && (
          <Typography variant="body2" color="textSecondary">
            Sub ends{' '}
            {format(parseISO(subscription.licence.expiresAt), 'dd. MMM')}
          </Typography>
        )}
    </Stack>
  );
}
